<template>
  <chart-card
    :chart-data="stockPieChart"
    chart-type="Pie"
    title="Pallets en Stock"
    :chartOptions="backgroundColor"
    style="max-height:450px;min-height: 450px;"
  >
    <template slot="header">
      <h5 class="card-title pb-5p">{{ i18nValues["palletsInStock"] }} </h5>
    </template>
    <template slot="footer">
      <div class="legend" style="padding-bottom: 10px">
        <div v-for="(label, index) in stockPieChart.labels" :key="label">
          <i
            class="fa fa-circle"
            :style="{ color: backgroundColor[index] }"
          ></i>
          {{ label }}: {{ stockPieChart.series[index] }}
        </div>
      </div>
    </template>

  </chart-card>
</template>

<script>
import { StatsCard, ChartCard } from "@/components/dashboard/index";
import BarChart from "@/components/dashboard/BarChart";
export default {
  name: "StockSection",
  props: {
    snapshot: Object,
    stockPieChart: Object,
  },
  components: {
    BarChart,
    ChartCard,
  },
  methods: {},
  data() {
    return {
      backgroundColor: [
        "#62B58F",
        "#fbc658",
        "#F2726F",
        "#434343",
        "#5a9ec3",
        "#dd9e55",
        "#dd2355",
        "#762355",
        "#172d55",
        "#ffbabc",
      ],
    };
  },
};
</script>
<style scoped>
.align-end {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
}
.pb-5p {
  padding-bottom: 5px;
}
</style>
